import DepositWithGlide from "./DepositWithGlide";

function App() {
  return <DepositWithGlide />;
}

export default App;
